'use strict';

let formValidation = require('../components/formValidation');

function displayMessage(success, msg, form) {
  const span = document.createElement('DIV');
  span.classList.add('alert', 'card-custom', `${success ? 'alert-success' : 'alert-danger'}`);
  span.setAttribute('role', 'alert');
  span.setAttribute('aria-live', 'polite');
  span.innerHTML = msg;
  form.parentNode.appendChild(span);

  setTimeout(function () {
    span.remove();
  }, 5000);
}

module.exports = {
  submitProfile: function () {
    if (window.submitProfileCalled) {
        return;
    }
    window.submitProfileCalled = true; // Flag globale per evitare doppie registrazioni
    let isProcessing = false;
    $('form.edit-profile-form').off('bouncerFormValid').on('bouncerFormValid', function (e) {
        let $form = $(this);
        let $submitButton = $form.find('button[type="submit"]');
        e.preventDefault();
        if (isProcessing) {
            return;
        }
        isProcessing = true;
        $submitButton.prop('disabled', true); // Disabilitazione immediata
        let url = $form.attr('action');
        window.$.spinner().start();
        $('form.edit-profile-form').trigger('profile:edit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            beforeSend: function () {
            },
            success: function (data) {
                window.$.spinner().stop();
                if (!data.success) {
                    formValidation($form, data);
                    isProcessing = false;
                    $submitButton.prop('disabled', false); // Riabilitiamo solo in caso di errore
                } else {
                    const editProfileForm = $('.edit-profile-form');
                    const msg = editProfileForm.data('success');
                    editProfileForm.append('<div class="alert edit-profile-alert alert-success card-custom text-center" role="alert">' + msg + '</div>');
                    setTimeout(function () {
                        $('.edit-profile-alert').remove();
                        location.href = data.redirectUrl; // Redirect elimina ogni problema di doppio invio
                    }, 5000);
                }
            },
            error: function (err) {
                window.$.spinner().stop();
                isProcessing = false;
                $submitButton.prop('disabled', false); // Riabilitiamo il pulsante in caso di errore
            }
        });
    });
  },

  submitPassword: function () {
    $('form.change-password-form').on('bouncerFormValid', function (e) {
      let $form = $(this);
      e.preventDefault();
      let url = $form.attr('action');
      window.$.spinner().start();
      $('form.change-password-form').trigger('password:edit', e);
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
          window.$.spinner().stop();
          if (!data.success) {
            formValidation($form, data);
          } else {
            location.href = data.redirectUrl;
          }
        },
        error: function (err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          }
          window.$.spinner().stop();
        },
      });
      return false;
    });
  },

  activateGiftCard: function () {
    $('form.new-giftcard').on('bouncerFormValid', function (e) {
      let form = e.target;
      e.preventDefault();
      let url = $(form).attr('action');
      window.$.spinner().start();
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $(form).serialize(),
        success: function (data) {
          window.$.spinner().stop();
          if (data.success) {
            displayMessage(true, data.msg, form);
            if (data.redirectUrl) {
              setTimeout(function () {
                window.location.href = data.redirectUrl;
              }, 3000);
            }
          } else {
            displayMessage(false, data.msg, form);
          }
        },
        error: function (err) {
          if (err.msg) {
            displayMessage(false, err.msg, form);
          }
          window.$.spinner().stop();
        },
      });
      return false;
    });
  },

  deleteGiftCard: function () {
    $('.giftcard-card').on('click', '.remove-giftcard', function (e) {
      e.preventDefault();
      let target = e.target;
      let url = $(this).data('action');
      window.$.spinner().start();
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        success: function (data) {
          window.$.spinner().stop();
          if (data.success) {
            displayMessage(true, data.msg, target);
          } else {
            displayMessage(false, data.msg, target);
          }
          if (data.redirect) {
            window.location.href = data.redirect;
          }
        },
        error: function (err) {
          if (err.msg) {
            displayMessage(false, err.msg, target);
          }
          window.$.spinner().stop();
        },
      });
      return false;
    });
  },
};
